<template>
  <CardViewer
    class="interaction-viewer"
    :text="text"
    :icon="icon"
    :fill="fill"
    :color="color"
    :cover="cover"
    :cardLayout="cardLayout"
    cardClassName="interaction-card"
    @open="postMessage()"
  >
    <iframe class="interaction-view-content" :class="{ 'readonly': readonly }" :src="src" frameborder="0"></iframe>
    <template #fullscreen>
      <iframe :class="{ 'readonly': readonly }" :src="src" frameborder="0"></iframe>
    </template>
  </CardViewer>
</template>

<script>
import CardViewer from './CardViewer'

export default {
  name: 'interaction-viewer',
  components: {
    CardViewer,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    configs: {
      type: Object,
    },
    studentInfo: {
      type: Object,
    },
    readonly: {
      type: Boolean,
    },
    fill: {
      type: String,
    },
    color: {
      type: String,
    },
    cover: {
      type: String,
    },
    cardLayout: {
      type: String,
      default: '',
    },
  },
  methods: {
    postMessage() {
      const iframe = document.querySelector('.interaction-viewer iframe')
      iframe.onload = () => {
        if(this.studentInfo) {
          iframe.contentWindow.postMessage({
            command: 'postStudentInfo',
            data: {
              studentId: this.studentInfo.PK_UserGuid,
              studentName: this.studentInfo.NickName || this.studentInfo.Name,
              studentAvatar: this.studentInfo.HeadPhotoPath,
              styles: this.configs.styles,
            },
          }, '*')
        }
        else {
          iframe.contentWindow.postMessage({
            command: 'postConfigs',
            configs: this.configs,
          }, '*')
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.interaction-view-content {
  width: 100%;
  height: 618px;
  position: relative;
  z-index: 1;
  border: 0;
  border-radius: 10px;
}
iframe {
  background-color: #fff;
  padding: 20px;
}
</style>